import type { LearningProgressRepository } from '@/domain/precon-supporter/learning-progress';
import { LearningProgress } from '@/domain/precon-supporter/learning-progress';
import { CourseId } from '@/domain/precon-supporter/value-objects';

/**
 * 講座完了ユースケース
 * 動画の視聴が最後まで完了した時に呼び出す
 */
export class CompleteLectureUseCase {
  constructor(private learningProgressRepository: LearningProgressRepository) {}

  async execute(params: {
    courseId: CourseId;
    lectureId: string;
  }): Promise<void> {
    // 進捗を取得
    let progress = await this.learningProgressRepository.findByCourseId(
      params.courseId
    );

    if (!progress) {
      // 【設計メモ】進捗未作成時の自動開始
      // 初回の動画視聴時に自動でコースを開始する（UX向上）
      // これにより、ユーザーは明示的な「コース開始」操作なしに受講を始められる
      progress = LearningProgress.create(params.courseId);
    }

    // 講座を完了としてマーク（新しいインスタンスを取得）
    const updatedProgress = progress.completeLecture(params.lectureId);

    // 保存
    await this.learningProgressRepository.save(updatedProgress);
  }
}
